window.addEventListener("DOMContentLoaded", () => {
    $('.btn-white').on('click', function ( e ) {
        $('.accordion-collapse.collapse.show').toggleClass('show');
        let target_attr = $(e.currentTarget).data('target').replace('#collapse-', '')
        let element = document.getElementById('card-' + target_attr);
        element.scrollIntoView();

        $('.btn-gray-outline').addClass('collapsed').removeClass('dark');
        $('.card .top-part .btn').removeClass('green-collapsed').addClass('btn-purple-outline');

        $(`#href-${target_attr}`).toggleClass('btn-purple-outline').toggleClass('green-collapsed')
        let view_more = $(`button[data-target='#collapse-${target_attr}']`).toggleClass('dark')
        $('.accordion-collapse.collapse.show').removeClass('show');
        $('#card-' + target_attr).find('.btn-gray-outline').removeClass('collapsed');
    });

    $('.btn-gray-outline.collapsed').on('click', function ( e ) {
        const target_attr = $(e.currentTarget).data('target').replace('#collapse-', '')
        const targetButton = $(`#href-${target_attr}`)
        const targetAccordion = $(`.accordion-collapse#collapse-${target_attr}`);
        targetButton.toggleClass("btn-purple-outline").toggleClass("green-collapsed")
        if ($('.card .top-part .btn').hasClass("green-collapsed"))
            $('.card .top-part .btn').not(targetButton).removeClass("green-collapsed").addClass("btn-purple-outline");
        targetAccordion.collapse('show')
        $('.accordion-collapse').not(targetAccordion).collapse('hide')
        if ($(e.currentTarget).hasClass('dark')) {
            $(e.currentTarget).removeClass('dark').addClass('collapsed')
        } else {
            $(`.btn-gray-outline`).removeClass('dark').addClass('collapsed')
            $(e.currentTarget).removeClass('collapsed').addClass('dark')
        }
        $(this).closest('.bottom-part').addClass('collapsed-part')
    });
})
